import React, { useContext } from "react";
import { FormContext } from "./AuditMain";
import BasicInfo1 from './Forms/BasicInfo1';
import BasicInfo2 from './Forms/BasicInfo2';
import BasicInfo3 from './Forms/BasicInfo3';
import BasicInfo4 from './Forms/BasicInfo4';
import BasicInfo5 from './Forms/BasicInfo5';
import BasicInfo6 from './Forms/BasicInfo6';
import BasicInfo7 from './Forms/BasicInfo7';
import BasicInfo8 from './Forms/BasicInfo8';


function Step() {
  const { activeStepIndex } = useContext(FormContext);
  let stepContent;
  switch (activeStepIndex) {
    case 0:
      stepContent = <BasicInfo1 />;
      break;
    case 1:
      stepContent = <BasicInfo2 />;
      break;
    case 2 :
      stepContent = <BasicInfo3 />;  
      break;
    case 3 :
        stepContent = <BasicInfo4 />; 
        break; 
    case 4 :
        stepContent = <BasicInfo5 />; 
        break; 
    case 5 :
        stepContent = <BasicInfo6 />; 
        break; 
    case 6 :
        stepContent = <BasicInfo7 />; 
        break;     
    case 7 :
        stepContent = <BasicInfo8 />; 
        break;         
    
    default:
      break;
  }

  return stepContent;
}

export default Step;